import * as React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import CommonTooltip from '../CommonTooltip';

// 🔹 i18n
import { useI18n } from '../../../i18n/I18nContext';

export default function EditorSwitch(props) {
  const { label, checked, sx, onChange, tooltip, ...other } = props;
  const { t } = useI18n();

  const switchControl = (
    <FormControlLabel
      sx={{ whiteSpace: 'nowrap' }}
      control={
        <Switch
          checked={checked}
          onChange={onChange}
        />
      }
      label={label ? t(label) : ''}
    />
  );

  return (
    <Box
      sx={{
        m: 1.5,
        ...sx
      }}
      {...other}
    >
      {tooltip !== undefined && tooltip.length > 0 ? (
        <CommonTooltip title={t(tooltip)}>
          {switchControl}
        </CommonTooltip>
      ) : (
        <>
          {switchControl}
        </>
      )}
    </Box>
  );
}